import Axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { LocalStorageKeys } from '../constants';

const getlLeadId = (): string =>
  localStorage.getItem(LocalStorageKeys.LEAD_ID) || '';

const axiosRequestConfiguration = (endpoint: string): AxiosRequestConfig => ({
  baseURL: `${process.env.REACT_APP_AUTO_ORCHESTRATOR_URL || ''}/${endpoint}`,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const createLead = (companyId: string): AxiosInstance => {
  const endpoint = `public/companies/${companyId}/leads`;

  return Axios.create({
    ...axiosRequestConfiguration(endpoint),
    method: 'POST',
  });
};

export const getExternalAutoInfo = (): AxiosInstance => {
  const endpoint = `public/leads/${getlLeadId()}/auto-external-info`;

  return Axios.create({
    ...axiosRequestConfiguration(endpoint),
    method: 'GET',
  });
};

export const sendLoanInfo = (): AxiosInstance => {
  const endpoint = `public/leads/${getlLeadId()}/loan-info`;

  return Axios.create({
    ...axiosRequestConfiguration(endpoint),
    method: 'PUT',
  });
};
export const sendTagExperiment = (): AxiosInstance => {
  const endpoint = `public/leads/${getlLeadId()}/tags`;

  return Axios.create({
    ...axiosRequestConfiguration(endpoint),
    method: 'POST',
  });
};
